<template>
 <div id="v3ChangePasswordDiv">
  <div id="v3ArrowDiv" @click="onBackClick()"><img id="v3Arrow" src="~assets/img/SdkV3/ArrowLeft.png"/></div>
  <div id="v3codTitleDiv">
  修改密码
  </div>
  <br>
  <div style="display:flex;flex-direction:row;align-items: center;justify-content: center;">
    <span style="font-size:xx-small;color:#574E4C">已绑定手机:</span>
    <span>{{$store.state.commonParameters.phone}}</span>
  </div>
  <div style="display:flex;flex-direction:row;align-items: center;justify-content: center;margin-top: 5px;">
    <input id="pwOneInput" placeholder="请输入6~12位新密码(字母或数字)" v-model="pwOne"/>
  </div>
  <div style="display:flex;flex-direction:row;align-items: center;justify-content: center;margin-top: 5px;">
    <input id="pwTwoInput" placeholder="请再次输入新密码(字母或数字)" v-model="pwAgain"/>
  </div>
  <div style="position:relative;display:flex;flex-direction:row;align-items: center;justify-content: center;margin-top: 5px;">
    <input id="pwCodeInput" placeholder="请输入验证码" v-model="verifyCode"/>
    <button v-if="!show" id="fetchCodeBtn" style="background: gray;">已发送({{count}})</button>
    <button v-else id="fetchCodeBtn" @click="getCode()">获取验证码</button>
  </div>
  <br>
  <div style="display:flex;flex-direction:row;align-items: center;justify-content:center;">
    <button id="modifyPswBtn" @click="modifyPassword()">修 改</button>
  </div>
  
 </div>
</template>

<script>
import getRequestParams from "@/signParams";
import { request } from '@/SdkV3/network/request';
 export default {
   data () {
     return {
      list:[1,2,3],
      pwOne: "",
      pwAgain: "",
      verifyCode: "",
      times:60,
      start:false,
      timeClock:null,
      show: true ,
      count: '',
      timer: null
     }
   },
   components: {
   },
   methods:{
    onBackClick(){
      this.$store.commit('updateChangePasswordShowState', false)
    },
    getCode(){
      if(this.checkInputValueInvalidate()){
        return;
      }
      const TIME_COUNT = 60;
      this.count = TIME_COUNT;
      this.show = false;
      let storeCommomParams = this.$store.state.commonParameters;
      storeCommomParams['type'] = 'find'
      // type 验证码类型，“free”为登录，“bind”为绑定手机，“unbind”为解绑手机，“register”为注册，“find”为修改密码
      let sendReqParams = getRequestParams({},storeCommomParams);
      request({
        url:this.urls.REBATE_SEND,
        params: {
          data: sendReqParams
        },
      }).then(res =>{
        // 开始倒计时
        if (!this.timer) {
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
              } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
              }
            }, 1000)
          }
      });
    },
    modifyPassword(){
      if(this.checkInputValueInvalidate()){
        return;
      }
      if (this.pwAgain !== this.pwOne) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "两次密码输入不正确"});
        return;
      }
      if (this.verifyCode.length < 1) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入验证码"});
        return;
      }
      // 修改密码
      let storeCommomParams = this.$store.state.commonParameters;
      let editPasswordReqParams = getRequestParams(
        {
          "password":this.pwOne,
          "repassword":this.pwAgain,
          "verify":this.verifyCode,
        },
        storeCommomParams);
      request({
        url:this.urls.REBATE_EDITPASSWORD,
        params: {
          data: editPasswordReqParams
        },
      }).then(res =>{
        // 修改密码成功
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "修改密码成功"});
        this.pwOne = "";
        this.pwAgain = "";
        this.verifyCode = "";
        this.count = '0';
        this.show = false;
        this.onBackClick();
      });
    },
    checkInputValueInvalidate(){
      if (this.pwOne.length < 6 || this.pwOne.length > 13) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入6~12位的密码"});
        return true;
      }
      if (this.pwAgain.length < 6 || this.pwAgain.length > 13) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "请输入6~12位的确认密码"});
        return true;
      }

      let containSpecial = RegExp(/[(\ )(\~)(\~)(\!)(\！)(\@)(\#)(\$)(\￥)(\%)(\^)(\……)(\&)(\*)(\()(\（)(\))(\）)(\-)(\_))(\——)(\+)(\=)(\[)(\【)(\])(\】)(\{)(\})(\|))(\、))(\)(\\)(\;)(\；)(\:)(\：)(\')(\‘)(\’)(\")(\“)(\”)(\,)(\，)(\.)(\。)(\/)(\《)(\<)(\>)(\》)(\?)(\？)(\)]+/);
      if (containSpecial.test(this.pwOne)) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "密码不能含有特殊字符！"});
        return true;
      }
      if (containSpecial.test(this.pwAgain)) {
        this.$store.commit("switchToast",{"showOrHide": true, "toastMessage": "确认密码不能含有特殊字符！"});
        return true;
      }
      return false;
    }
   }
 }
</script>

<style>
#v3ChangePasswordDiv{
  position: relative;
  display: flex;
  flex-direction: column;
  
}
#v3codTitleDiv{
  background-color: white;
  color: #3E3E3E;
  font-size: small;
  font-weight: bold;
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #B4B4B4;
}
#v3ArrowDiv{
  position:absolute;
  float: left;
  height: 40px;
  display: flex;
  align-items: center;
}
#v3Arrow{
  height: 25px;
  width: 25px;
  object-fit: scale-down;
}

#v3ChangePasswordDiv input {
  outline: none;
  /* border: none; */
  padding-left: 5px;
  border: 1px solid #B4B4B4;
  border-radius: 5px;
  font-size: x-small;
  height: 35px;
  width: 90%;
}
#fetchCodeBtn {
  text-align: center;
  border-radius: 6px;
  background: -webkit-linear-gradient(left, #FB6C34,#F84524);
  color: white;
  border: none;
  position:absolute;
  float: right;
  right: 20px;
  font-size: xx-small;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
}
#modifyPswBtn{
  background: -webkit-linear-gradient(left, #FB6C34,#F84524);
  border-radius: 10px 10px 10px 10px;
  padding-top: 3px;
  padding-bottom: 3px;
  height: 30px;
  width: 94%;
  margin-left: 3%;
  color: white;
  font-size: small;
  border: none;
}

 
</style>


// WEBPACK FOOTER //
// src/views/SdkV3/mine/changepassword/V3ChangePassword.vue